// Local: podsumowanie płatności z polem unsettled (tylko w local)
// @ts-nocheck

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

interface ISettlementsSummaryItem {
  payments: {
    count: number;
  };
  invoices: {
    count: number;
  };
  total: {
    value: number;
    value_formatted: string;
  };
  currency: string;
}

export type IResponse = Record<
  'paid' | 'expired' | 'upcoming' | 'unsettled',
  ISettlementsSummaryItem
>;

const getSettlementsSummary = (): Promise<IResponse> => axios.get('/settlements/summary');

export const useGetSettlementsSummary = (options?: UseQueryOptions<IResponse, IError>) =>
  useQuery<IResponse, IError>(['payments-summary'], () => getSettlementsSummary(), options);
